/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type FC } from 'react';

import { Stack } from '@atlaskit/primitives/compiled/stack';
import { jsx } from '@atlaskit/css';

import { type SearchResult } from './ContentTreeSearchBase.tsx';
import { ContentSearchResultItem } from './ContentSearchResultItem.tsx';

type ContentSearchResultListProps = {
	pagesList: SearchResult[];
	onItemClick?: (id: string, index?: number) => void;
	spaceKey?: string;
	contentId?: string;
};

const getContentIdFromSearchResultId = (id: string | null, type?: string) => {
	if ((type === 'database' || type === 'embed') && id) {
		return id.split('/').pop() || null;
	}

	return id;
};

export const ContentSearchResultList: FC<ContentSearchResultListProps> = ({
	pagesList,
	onItemClick,
	contentId,
}) => {
	return (
		<Stack testId="content-search-result-list" role="list">
			{pagesList.map(
				(
					{ title, id, hasRestrictions, hasInheritedRestrictions, displayEmoji, type, subType },
					index,
				) => {
					const isCurrentPage = Boolean(contentId && contentId === id);
					const parsedId = getContentIdFromSearchResultId(id, type);

					const item = {
						id: parsedId || '',
						hasRestrictions,
						hasInheritedRestrictions,
						type,
						subType,
					};

					return (
						<ContentSearchResultItem
							key={id}
							index={index}
							title={title || ''}
							item={item}
							onItemClick={onItemClick}
							isCurrentPage={isCurrentPage}
							displayEmoji={displayEmoji}
						/>
					);
				},
			)}
		</Stack>
	);
};
